import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 忽略 ResizeObserver 循环警告
const resizeObserverErr = window.onerror
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return true
  }
  return resizeObserverErr ? resizeObserverErr(message, ...args) : false
}

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import '@/styles/init.css'
import '@/styles/variables.scss'
import '@/styles/theme.scss'
import '@/styles/page.scss'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')

